module.exports = __webpack_public_path__ + "static/media/germany-colors.4cd24d92.jpg";